import { render } from "./sel-badge.vue?vue&type=template&id=021af5d8&scoped=true"
import script from "./sel-badge.vue?vue&type=script&lang=js"
export * from "./sel-badge.vue?vue&type=script&lang=js"

import "./sel-badge.vue?vue&type=style&index=0&id=021af5d8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021af5d8"]])

export default __exports__